import { render, staticRenderFns } from "./category-edit.vue?vue&type=template&id=eaeabb7a&scoped=true"
import script from "./category-edit.vue?vue&type=script&lang=js"
export * from "./category-edit.vue?vue&type=script&lang=js"
import style0 from "./category-edit.vue?vue&type=style&index=0&id=eaeabb7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaeabb7a",
  null
  
)

export default component.exports